import { createActionCreator, createReducer } from 'deox';
import { UserSongs, Audio } from 'types/Audio';
import { AppState } from 'types/AppState';

export const defaultUserSongs: UserSongs = {
  songs: [],
  loading: false
};

export const uploadUserTrack = createActionCreator(
  'USER_SONG/UPLOAD_USER_SONG',
  resolve => (file: File) => resolve({ file })
);

export const cancelUploadUserSong = createActionCreator('USER_SONG/CANCEL_UPLOAD_USER_SONG');

export const addUserSong = createActionCreator(
  'USER_SONG/ADD_USER_SONG',
  resolve => (song: Audio) => resolve(song)
);

export const setLoading = createActionCreator(
  'USER_SONG/SET_LOADING',
  resolve => (loading: boolean) => resolve(loading)
);

export const setUserSongLoadingCancelId = createActionCreator(
  'USER_SONG/SET_LOADING_CANCEL',
  resolve => (cancelId: UserSongs['cancelId']) => resolve(cancelId)
);

export const userSongs = createReducer(defaultUserSongs, handle => [
  handle(setUserSongLoadingCancelId, (state, { payload }) => ({ ...state, cancelId: payload })),
  handle(setLoading, (state, { payload }) => ({ ...state, loading: payload })),
  handle(addUserSong, (state, { payload }) => ({
    songs: [...state.songs, payload],
    loading: false
  }))
]);

export const getUserSongs = (state: AppState) => state.userSongs.songs;
export const isUserSongUploading = (state: AppState): boolean => state.userSongs.loading;
export const getUserSongsCancelUploadId = (state: AppState): UserSongs['cancelId'] =>
  state.userSongs.cancelId;
